import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 Fires when there is an error for which no Event has been defined
 (e.g. other app errors, technical glitch, etc..).
 Fire this Event only when the error is not covered by another more specific QOS Event.
 */
export const undefinedErrorBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.QOS,
  eventName: EVENT_NAMES.UNDEFINED_ERROR,
  label:
    action.payload && action.payload.error && action.payload.error.message
      ? action.payload.error.message
      : 'Unknown error',
  value: action.payload,
});
